import { atom, useRecoilState } from 'recoil'

interface SortState {
  by: string;
  direction: string;
}

type SortOutput = [
  { direction: string; by: string },
  (sort: string) => void
]

const sortState = atom<SortState>({
  key: 'CustomersSort',
  default: {
    by: 'created_at',
    direction: 'desc',
  },
});

export const useSort = ():SortOutput => {
  const [{ direction, by }, setSort] = useRecoilState(sortState);
  return [
    { direction, by },
    (sort: string) => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc';
        setSort({ by: sort, direction: newDirection });
      } else {
        setSort({ by: sort, direction: 'asc' });
      }
    },
  ]
};